import React from "react";
import { Row, Col } from "react-bootstrap";
import { Addon, Group, Gym, Pt } from "../../../exports/Images";
import DoughnutChart from "../../components-react/DoughnutChart";
import GroupBarChart from "../../components-react/GroupBarChart";

function ProfitAndLossAccount({ settlementDetails }) {
  const addValue = (item1, item2) => {
    return Math.round(parseFloat(item1) + parseFloat(item2));
  };

  const regularOnline =
    parseInt(settlementDetails?.data?.[0]?.online) ||
    parseInt(settlementDetails?.data?.online) ||
    0;
  const otherOnline = parseInt(settlementDetails?.online) || 0;
  const sumOfAllOnline = regularOnline + otherOnline;
  const totalOnlineTransaction = Math.round((sumOfAllOnline * 2.5) / 100) || 0;

  const regularCash =
    parseInt(settlementDetails?.data?.[0]?.cash) ||
    parseInt(settlementDetails?.data?.cash) ||
    0;
  const otherCash = parseInt(settlementDetails?.cash) || 0;
  const sumOfAllCash = regularCash + otherCash;

  const sumOfAll = Math.round(sumOfAllOnline + sumOfAllCash);

  const toalPercentageCash = Math.round((sumOfAllCash / sumOfAll) * 100) || 0;
  const toalPercentageOnline =
    Math.round((sumOfAllOnline / sumOfAll) * 100) || 0;

  return (
    <div className="profitAndLossAccountContainer">
      <Row>
        <Col>
          <h3 className="titleHeadPnF">Profit & Loss Account</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <Row>
            <div className="erpCardsContainer">
              <div className="erpCard">
                <div className="erpCardTitle">
                  <h5 className="title">Earnings</h5>
                </div>
                <div className="erpNetRevenue">
                  <span className="labelname">Net Revenue</span>
                  <h3 className="net">
                    ₹
                    {addValue(
                      settlementDetails?.data?.[0]?.net_revenue || 0,
                      settlementDetails?.cash_flow_other_membership
                        ?.net_revenue || 0
                    )}
                  </h3>
                </div>
                <div className="erpLists">
                  <div className="erpListBox">
                    <div className="iconAndLabel">
                      <div className="iconContainer">
                        <img src={Gym} alt="icon" />
                      </div>
                      <p className="name">Gym Membership</p>
                    </div>
                    <p className="amount">
                      ₹ {settlementDetails?.gym_share_final || 0}
                    </p>
                  </div>
                  <div className="erpListBox">
                    <div className="iconAndLabel">
                      <div className="iconContainer">
                        <img src={Addon} alt="icon" />
                      </div>
                      <p className="name">Addons</p>
                    </div>
                    <p className="amount">
                      ₹
                      {settlementDetails?.cash_flow_other_membership
                        ?.share_details?.[0]?.net_revenue || 0}
                    </p>
                  </div>
                  <div className="erpListBox">
                    <div className="iconAndLabel">
                      <div className="iconContainer">
                        <img src={Pt} alt="icon" />
                      </div>
                      <p className="name">Personal Training</p>
                    </div>
                    <p className="amount">
                      ₹
                      {settlementDetails?.cash_flow_other_membership
                        ?.share_details?.[1]?.net_revenue || 0}
                    </p>
                  </div>
                  <div className="erpListBox">
                    <div className="iconAndLabel">
                      <div className="iconContainer">
                        <img src={Group} alt="icon" />
                      </div>
                      <p className="name">Nutrition</p>
                    </div>
                    <p className="amount">
                      ₹
                      {settlementDetails?.cash_flow_other_membership
                        ?.share_details?.[2]?.net_revenue || 0}
                    </p>
                  </div>
                </div>
              </div>
              <div className="erpCard">
                <div className="erpCardTitle graph">
                  <h5 className="title">Revenue share</h5>
                </div>

                <div className="erpCardBody">
                  <DoughnutChart graphData={settlementDetails} />
                </div>
              </div>
              <div className="erpCard">
                <div className="erpCardTitle">
                  <h5 className="title">Payment mode</h5>
                </div>

                <div className="erpCardBody">
                  <div className="progress">
                    <div
                      className="progress-bar progress-bar-success"
                      role="progressbar"
                      style={{
                        width: `${toalPercentageCash}%`,
                        background: "#8414AB",
                      }}
                    >
                      <span className="sharePercent">
                        {toalPercentageCash}%
                      </span>
                    </div>
                    <div
                      className="progress-bar progress-bar-warning"
                      role="progressbar"
                      style={{
                        width: `${toalPercentageOnline}%`,
                        background: "#FFC327",
                      }}
                    >
                      <span className="sharePercent">
                        {toalPercentageOnline}%
                      </span>
                    </div>
                  </div>

                  <div className="progressLabelContainer">
                    <div className="progressLabel">
                      <div className="colorName">
                        <div className="progressLabelColor violet"></div>
                        <p className="labelName">Cash</p>
                      </div>
                      <p className="amount">₹{Math.round(sumOfAllCash)}</p>
                    </div>
                    <div className="progressLabel">
                      <div className="colorName">
                        <div className="progressLabelColor yellow"></div>
                        <p className="labelName">Online</p>
                      </div>
                      <p className="amount">₹{Math.round(sumOfAllOnline)}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Row>
          <Row>
            <div className="erpCardsContainer ogContainer">
              <div className="erpCard" style={{ height: "410px" }}>
                <div className="erpCardTitle">
                  <h5 className="title">Other Charges</h5>
                </div>
                <div className="erpLists">
                  <div className="erpListBox">
                    <p className="name">GST on WTF Facilities</p>
                    <p className="amount">
                      ₹{settlementDetails?.gst_wtf_facilities || 0}
                    </p>
                  </div>
                  <div className="lineGray"></div>
                  <div className="erpListBox">
                    <p className="name">Goverment GST</p>
                    <p className="amount">
                      ₹{settlementDetails?.data?.[0]?.gst || 0}
                    </p>
                  </div>
                  <div className="lineGray"></div>
                  <div className="erpListBox">
                    <p className="name">Total Online Transaction</p>
                    <p className="amount">₹ {totalOnlineTransaction || 0}</p>
                  </div>
                  <div className="lineGray"></div>
                  <div className="erpListBox">
                    <p className="name">Bank charges(Online 2.5%)</p>
                    <p className="amount">
                      ₹{settlementDetails?.data?.[0]?.gateway_charges || 0}
                    </p>
                  </div>
                </div>
                <div className="totalAmountContainer">
                  <p className="total">Total</p>
                  <p className="totalAmount">
                    ₹{settlementDetails?.data?.[0]?.net_revenue || 0}
                  </p>
                </div>
              </div>

              <div className="erpCard groupChartContainer">
                <div className="erpCardTitle">
                  <h5 className="title">Gross vs Net revenue</h5>
                </div>

                <div className="erpCardBody groupchart">
                  <GroupBarChart graphData={settlementDetails} />
                </div>
              </div>
            </div>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default ProfitAndLossAccount;
